import React from 'react'

import dayjs from 'dayjs'

import { DateCalendar } from '../..'
import { NewCupon } from '../../../types'
import { Spacer } from '../../global'

import { ModalRow } from './styles'

const DateRow = ({
  newCupon,
  updateDate,
}: {
  newCupon: NewCupon
  updateDate: (newDate: dayjs.Dayjs | null) => void
}) => {
  return (
    <ModalRow>
      <div className="title">Fecha de inicio</div>
      <Spacer height={18} />
      <div className="date-row">
        <DateCalendar
          referenceDate={newCupon.initDate}
          handleDate={updateDate}
          defaultValue={dayjs()}
          fullWidth={false}
        />

        {newCupon?.dueDate && (
          <div className="disclaimer">
            VENCE {dayjs(newCupon.dueDate).format('DD-MM-YYYY')}{' '}
          </div>
        )}
      </div>
      {newCupon.amountOfClasses > 1 && (
        <div className="subtitle">Duración 30 días desde el inicio.</div>
      )}
    </ModalRow>
  )
}

export default DateRow
